"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
type WhiteMenuBarProps = {
  tabs?: string[];
  onChange?: (index: number) => void;
};
const defaultTabs = ["அனைத்து", "செய்தி", "திரை/சிறு திரை", "நடிகர்கள்", "நடிகைகள்", "விளையாட்டு", "ஆன்மிகம்"];
export default function WhiteMenuBar(t0) {
  const $ = _c(11);
  const {
    tabs: t1,
    onChange
  } = t0;
  const tabs = t1 === undefined ? defaultTabs : t1;
  const [active, setActive] = useState(0);
  let t2;
  if ($[0] !== onChange) {
    t2 = index => {
      setActive(index);
      onChange?.(index);
    };
    $[0] = onChange;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleClick = t2;
  let t3;
  if ($[2] !== active || $[3] !== handleClick || $[4] !== tabs) {
    let t4;
    if ($[6] !== active || $[7] !== handleClick) {
      t4 = (tab, index_0) => <button key={index_0} onClick={() => handleClick(index_0)} className="relative pb-1 whitespace-nowrap font-bold leading-none"><span className={`inline-block font-black text-12-tamil-900 transition-opacity duration-150 ${active === index_0 ? "text-215EF9 text-14-tamil-700" : "text-808080 text-14-tamil-500"}`}>{tab}</span><span className="absolute left-0 -bottom-2 w-full h-[2px] bg-[#215EF9] rounded-full transition-transform duration-200" style={{
          transform: active === index_0 ? "scaleX(1)" : "scaleX(0)",
          transformOrigin: "left"
        }} /></button>;
      $[6] = active;
      $[7] = handleClick;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    t3 = tabs.map(t4);
    $[2] = active;
    $[3] = handleClick;
    $[4] = tabs;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <div className="w-full border border-DCDCDC bg-F8F8F8 h-[40px]"><div className="flex gap-8 px-4 overflow-x-auto no-scrollbar h-full items-center">{t3}</div></div>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}